import angular from 'angular';
import responseComponent from './response.component';
import ResponseService from './response.service';
import responseConfig from './response.config';
import ModalExperienceController from '../confirmation-order/modal-experience/modal-experience.controller';

let responseModule = angular.module('app.response', [])
    .controller('ModalExperienceController', ModalExperienceController)
    .component('response', responseComponent)
    .service('ResponseService', ResponseService)
    .config(responseConfig)
;

export default responseModule;



// WEBPACK FOOTER //
// ./www/components/response/response.js